import { adaptiveSwiper } from '../../../application/application/adaptive-swiper'
import { Swiper, Pagination } from 'swiper'
Swiper.use([Pagination])

export function createProductSlider(rootElement) {
  const swiperElement = rootElement.querySelector('.swiper-container')
  adaptiveSwiper(Swiper, {
    swiperElement,
    settings: {
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      }
    },
    mediaQuery: '(min-width: 1025px)'
  })
}
